module.exports = __webpack_public_path__ + "assets/scooter_light.0a1fd537.svg";